var _circle, _circle2, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComplete = function SvgComplete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 80,
    viewBox: "0 0 210 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 106,
    cy: 40,
    r: 40,
    fill: "#2A31F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 106,
    cy: 40,
    r: 36,
    fill: "#2A31F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.379 31.813L116.082 28.5065C116.027 28.4515 115.962 28.4079 115.89 28.3781C115.818 28.3483 115.741 28.333 115.664 28.333C115.586 28.333 115.509 28.3483 115.437 28.3781C115.366 28.4079 115.3 28.4515 115.246 28.5065L101.32 42.4413C101.265 42.4963 101.2 42.5399 101.128 42.5697C101.057 42.5994 100.98 42.6148 100.902 42.6148C100.824 42.6148 100.748 42.5994 100.676 42.5697C100.604 42.5399 100.539 42.4963 100.484 42.4413L97.1869 39.1347C97.1321 39.0797 97.0669 39.0361 96.9952 39.0063C96.9235 38.9766 96.8466 38.9613 96.7689 38.9613C96.6912 38.9613 96.6143 38.9766 96.5426 39.0063C96.4709 39.0361 96.4057 39.0797 96.3509 39.1347L93.0537 42.4413C92.943 42.552 92.8809 42.7022 92.8809 42.8587C92.8809 43.0153 92.943 43.1655 93.0537 43.2762L100.484 50.7077C100.539 50.7627 100.604 50.8063 100.676 50.8361C100.748 50.8659 100.824 50.8812 100.902 50.8812C100.98 50.8812 101.057 50.8659 101.128 50.8361C101.2 50.8063 101.265 50.7627 101.32 50.7077L119.379 32.6397C119.487 32.5293 119.548 32.3809 119.548 32.2264C119.548 32.0718 119.487 31.9234 119.379 31.813Z",
    fill: "#2A31F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 14,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 26,
    r: 3,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 35,
    r: 3,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 54,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 62,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 26,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 20,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 45,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 28,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 45,
    r: 2,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 31,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 50,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 49,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 33,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 44,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 22,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 41,
    r: 1,
    fill: "#2A31F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 17,
    r: 1,
    fill: "#2A31F7"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "complete.add865d6bc0df3b759daa85a04830397.svg";